import { DataTestId, LocalizedCurrencySimpleValue, SimpleAmount, TextKey } from '@mews-distributor/common';
import { LocalizedProperty, LocalizedPropertyObject, LocalizedText } from '@mews/framework/localization';
import { Stack, Typography } from '@optimus-web/core';

import { ProductInformationText, ProductInformationTextProps } from './ProductInformationText';

export interface ProductOrderProps extends ProductInformationTextProps {
    id: string;
    isDisplayingPrice: boolean;
    isIncludedInRate: boolean;
    name: LocalizedPropertyObject;
    totalPrice: SimpleAmount;
}

export const ProductOrder = ({
    name,
    totalPrice,
    isDisplayingPrice,
    isIncludedInRate,
    ...infoTextProps
}: ProductOrderProps) => (
    <Stack spacing="200" itemAlignment="center" alignment="center" distribution="space-between">
        <Stack vertical spacing="0" alignment="center">
            <Typography textStyle="bodyMediumStrong" variant="secondary" data-test-id="product" as="div">
                <LocalizedProperty property={name} />
            </Typography>
            {isDisplayingPrice ? (
                <Typography
                    textStyle="bodySmallStrong"
                    variant="secondary"
                    data-test-id={DataTestId.AdditionalInfo}
                    as="div"
                >
                    <ProductInformationText {...infoTextProps} />
                </Typography>
            ) : null}
        </Stack>

        <Typography textStyle="bodySmallStrong" variant="secondary" as="div">
            {isIncludedInRate ? (
                <LocalizedText textKey={TextKey.IncludedInRate} />
            ) : (
                <LocalizedCurrencySimpleValue value={totalPrice} />
            )}
        </Typography>
    </Stack>
);
